import api from "./axios";

class ServiceInspectionAudio {
  async uploadAudio(file, durationSeconds, onUploadProgress) {
    const formData = new FormData();
    formData.append("audio", file);
    formData.append("durationSeconds", String(durationSeconds || 0));

    const { data } = await api.post("/inspections/audio/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress,
    });
    return data;
  }

  /* TRANSCRIÇÃO EM STANDBY
  async uploadAndTranscribe(
    file,
    durationSeconds,
    transcriptionContext,
    onUploadProgress
  ) {
    const formData = new FormData();
    formData.append("audio", file);
    formData.append("durationSeconds", String(durationSeconds || 0));
    formData.append(
      "transcriptionContext",
      JSON.stringify(transcriptionContext || {})
    );

    const { data } = await api.post(
      "/inspections/audio/upload-and-transcribe",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress,
      }
    );
    return data;
  }

  async getTranscription(jobId) {
    const { data } = await api.get(
      `/inspections/audio/transcriptions/${encodeURIComponent(jobId)}`
    );
    return data;
  }

  async retryTranscription(key, mimeType, transcriptionContext) {
    const { data } = await api.post("/inspections/audio/retranscribe", {
      key,
      mimeType,
      transcriptionContext: transcriptionContext || {},
    });
    return data;
  }
  */

  async deleteAudio(key, inspectionId) {
    await api.delete("/inspections/audio", {
      data: { key, inspectionId: inspectionId || null },
    });
  }
}

export default new ServiceInspectionAudio();
